import { Id } from "./id";
import { WorkloadPeriod } from "./workloadPeriod";
import { ResourceTypes } from "./resourceTypes";

type ResourceWorkload = {
  uuid: Id;
  name: string;
  periods: WorkloadPeriod[];
  projectsCount: number;
  type: ResourceTypes;
  avatarUrl: string;
};

const resourceWorkload: ResourceWorkload = {
  uuid: "",
  name: "",
  periods: [],
  projectsCount: 0,
  type: ResourceTypes.HUMAN,
  avatarUrl: "",
};

export type { ResourceWorkload };

export { resourceWorkload };
